module.exports = __webpack_public_path__ + "static/img/07.1779e91f.png";